/* tslint:disable */
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { PopupModule } from "@progress/kendo-angular-popup";
import { HotkeysModule } from "../../../hotkeys/hotkeys.module";
import { CPTranslateModule } from "../../../translate";
import { FocusModule } from "../../directives/focus/focus.module";
import { DraggingModule } from "../../directives/touch.drag/touch.module";
import { ButtonModule } from "../button/button.module";
import { CheckboxModule } from "../checkbox/checkbox.module";
import { BubblePopupComponent } from "./bubble/bubble.popup.component";
import { PopupButtonsDoubleOkCancelComponent } from "./buttons/popup.buttons.double.ok.cancel.component";
import { PopupButtonsOkCancelComponent } from "./buttons/popup.buttons.ok.cancel.component";
import { PopupButtonsOkComponent } from "./buttons/popup.buttons.ok.component";
import { PopupButtonsOkWithCheckBoxCancelComponent } from "./buttons/pupup.buttons.with.checkbox.ok.cancel.components";
import { ErrorPopupComponent } from "./error/error.popup.component";
import { ExpandableErrorComponent } from "./expandable.error/expandable.error.component";
import { InfoPopupComponent } from "./info/info.popup.component";
import { PopupComponent } from "./popup.component/popup.component";
import { ResizablePopupComponent } from "./popup.component/resizable.popup.component/resizable.popup.component";
import { StaticPopupComponent } from "./popup.component/static.popup.component/static.popup.component";
import { WarningPopupComponent } from "./warning/warning.popup.component";

@NgModule({
	declarations: [
		PopupButtonsDoubleOkCancelComponent,
		WarningPopupComponent,
		InfoPopupComponent,
		ErrorPopupComponent,
		PopupButtonsOkCancelComponent,
		BubblePopupComponent,
		PopupComponent,
		StaticPopupComponent,
		ResizablePopupComponent,
		PopupButtonsOkComponent,
		ExpandableErrorComponent,
		PopupButtonsOkWithCheckBoxCancelComponent
	],
	exports: [
		PopupComponent,
		StaticPopupComponent,
		ResizablePopupComponent,
		BubblePopupComponent,
		PopupButtonsOkCancelComponent,
		PopupButtonsOkComponent,
		PopupButtonsDoubleOkCancelComponent,
		WarningPopupComponent,
		InfoPopupComponent,
		ErrorPopupComponent,
		ExpandableErrorComponent,
		PopupButtonsOkWithCheckBoxCancelComponent
	],
	imports: [
		PopupModule,
		DraggingModule,
		CommonModule,
		CPTranslateModule,
		ButtonModule,
		HotkeysModule,
		FocusModule,
		CheckboxModule,
		FormsModule		
	]
})
export class CPPopUpModule {
}
